import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

import type { GateDecisionStatus } from '@/types'

/**
 * Tailwind class-name helper used by shadcn/ui components.
 * Merges conflicting classes deterministically so tokens never double up.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

// Shared, present-tense triad labels for gate / briefing decisions. The API
// keeps the past-tense status strings (``approved``/``edited``/``rejected``)
// for backwards compatibility, but every visible button across G1–G5 + the
// briefing panel now reads ``Approve / Edit / Reject`` so the user sees one
// vocabulary instead of four (plan §P0.1).
const DECISION_LABELS: Record<GateDecisionStatus, string> = {
  pending: 'Pending',
  approved: 'Approve',
  edited: 'Edit',
  rejected: 'Reject',
  // Gate G3.7 Phase 0 (plan §2.3) — explicit opt-out outcome.
  // Surfaces in the gate Decision Log so the architect can see
  // which findings were intentionally elided vs. resolved.
  skipped: 'Skip',
}

export function decisionLabel(status: GateDecisionStatus): string {
  return DECISION_LABELS[status] ?? status
}
